<template>
  <div class="doencas-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form :group-label="$t('Cronicas')">
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12">
            <v-textarea
              v-model="fields.doencas"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Doencas')"
            />
          </v-col>
        </v-row>
      </field-group-form>
      <field-group-form :group-label="$t('Alergias')">
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12">
            <v-textarea
              v-model="fields.alergiaAlimentar"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Alimentos')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12">
            <v-textarea
              v-model="fields.alergiaMedicamento"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Medicamentos')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12">
            <v-textarea
              v-model="fields.alergiaOutros"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Outros')"
            />
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { updateData } from "@/services";
export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm },
  data: () => ({
    fields: {
      doencas: "",
      alergiaAlimentar: "",
      alergiaMedicamento: "",
      alergiaOutros: "",
    },
  }),
  watch: {
    "store.showModalDataForm"() {
      this.fields = { ...this.fields, ...this.data };
      this.fields.doencas = this.$options.filters.toPT_BRCapitalize(
        this.fields.doencas
      );
      this.fields.alergiaAlimentar = this.$options.filters.toPT_BRCapitalize(
        this.fields.alergiaAlimentar
      );
      this.fields.alergiaMedicamento = this.$options.filters.toPT_BRCapitalize(
        this.fields.alergiaMedicamento
      );
      this.fields.alergiaOutros = this.$options.filters.toPT_BRCapitalize(
        this.fields.alergiaOutros
      );
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);
  },
  methods: {
    onSave() {
      updateData(this, "pet", this.fields);
    },
  },
};
</script>

<style scoped></style>
